<template>
  <div class="goods-anchor carrier-list-data">
    <LoginOrPayView  v-if="!isVip"  vip-text="升级版本权益后<br/>即可查看更多商品销售详情数据分析"/>
    <div v-if="isVip && $_.get(info, 'data.length') !== 0">
      <router-link
        :to="`/live/${$_.get(item, 'anchorId')}/${$_.get(item, 'liveStreamLogId')}`"
        v-for="(item, index) in info"
        :key="`${item.anchorId}${index}`"
        class="item-default"
      >
        <div class="commodity-sort">{{ index + 1 }}</div>
        <img
          class="live-poster"
          :src="$changeCDN($_.get(item, 'liveStreamLog.poster'))"
          alt="封面"
          :onerror="onerror"
        />
        <div>
          <div class="align">
            <img class="anchor-icon" :src="$_.get(item, 'anchor.avatar')" alt="头像" />
            <div class="item-name" >{{ $_.get(item, 'anchor.name') }}</div>
          </div>
          <div class="live-start-time">
            {{ formatDate(item) }}开播，时长{{
              $dateLong({
                startTime: $_.get(item, 'liveStreamLog.startTime'),
                endTime: $_.get(item, 'liveStreamLog.stopTime'),
                h: true,
                m: true,
              })
            }}
          </div>
        </div>
        <div class="data-for-detail">
          <div class="data-title">关联销售额</div>
          <div class="data-number data-number-red">¥{{ $retainWan($_.get(item, 'sales')) }}</div>
          <div class="data-title data-title-sec">关联销量</div>
          <div class="data-number">{{ $retainWan($_.get(item, 'salesVolume')) }}</div>
        </div>
      </router-link>
    </div>
    <NoneData v-if="info && $_.get(info, 'data.length') === 0" style="margin-top: 1rem" />
  </div>
</template>

<script>
export default {
  props: {
    params:{ type:Object, default: () => ({}) },
    title:{ type:Number, default:0 }
  },
  data() {
    return {
      info:[],
      onerror: `if(!this.src.includes('.webp')){this.src=this.src.replace('.jpg','.webp')}else{this.src='https://s6.bihukankan.com/common/default.png'}`
    };
  },
  watch:{
    params:{
      deep:true,
      handler(){
        this.getData()
      }
    },
    title(){
      this.getData()
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData(){
      if(this.$props.title !== 2 || !this.isVip){ return }
      this.$showLoading();
      const res = await this.$api.get(`v2/commodity/${this.$route.params.id}/liveStream`,{params:this.$props.params}).catch(_=> ({data:[]}))
      this.info = res.data || []
      this.$toast.clear();
    },
    formatDate(val) {
      return moment(this.$_.get(val, 'liveStreamLog.startTime') * 1000).format('MM-DD HH:mm');
    }
  },
  computed:{
    isVip: ( that = this ) => ( that.$store.state.userLevel && that.$store.state.userLevel <= 96 )
  }
};
</script>

<style lang="less" scoped>
.goods-anchor {
  .near-days-anchor-sell {
    text-align: center;
    line-height: 0.8rem;
    height: 0.8rem;
    color: #a1aebf;
    font-size: 0.28rem;
    background: #fff;
    margin-bottom: 0.1rem;
  }
}

.live-poster {
  width: 1rem;
  height: 1rem;
  margin-right: 0.1rem;
  object-fit: cover;
}

.anchor-icon {
  width: 0.6rem;
  height: 0.6rem;
  margin-right: 0.1rem;
  border-radius: 100%;
}

.live-start-time {
  font-size: 0.2rem;
  color: #a1aebf;
  margin-top: 0.2rem;
}
.item-name{
  width: 2.9rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
